import { CustomTableEventModel } from '@/components/table/model/CutomTableEvent.model.ts';

export const customTableEventDispatcher = (
  event: CustomTableEventModel,
  data?: Record<string, unknown>,
) => {
  window.dispatchEvent(new CustomEvent(event, { detail: data }));
};
